<template>
	<div class="toast" v-show="isShown">
		<div class="toast-message">{{ message }}</div>
	</div>
</template>


<script>
export default {
		props: {
		  message: {
			type: String,
			required: false,
			default: '',
		  },
		  timeout: {
			type: Number,
			required: false,
			default: 500,
		  },
		},
		data() {
		  return {
			isShown: false,
			timer: null,
		  };
		},
		methods: {
		  show(autoHide = true) {
			this.isShown = true;
	  
			if (autoHide) {
			  this.startTimer();
			}
		  },
		  hide() {
			this.isShown = false;
			this.stopTimer();
		  },
		  startTimer() {
			if (this.timer) {
			  this.stopTimer();
			}
	  
			this.timer = setTimeout(this.hide, this.timeout);
		  },
		  stopTimer() {
			clearTimeout(this.timer);
			this.timer = null;
		  },
		},
		template: `
		  <div>
			<slot></slot>
		  </div>
		`,
	  }
</script>